// extracted by mini-css-extract-plugin
export default {"customTitle":"Title_customTitle__lRdgY","titleSection":"Title_titleSection__jpgX+"};